import { bannerSettingsRestHooks } from '../store/BannerSettings/BannerSettingsSlice';

const useBannerSettings = () => {
  const { loadBannerSettings, updateBannerSetting } =
    bannerSettingsRestHooks.use();

  const updateAndLoadSettings = async (...params) => {
    await updateBannerSetting(...params);
    loadBannerSettings();
  };

  return {
    updateAndLoadSettings,
  };
};

export default useBannerSettings;
